import React, { Suspense, useState, useEffect } from 'react'
import { Canvas } from '@react-three/fiber'
import { Physics, usePlane } from '@react-three/cannon'
import { AdaptiveDpr, Preload } from '@react-three/drei'
import {
  Person,
  HologramConsole,
  Skybox,
  Trees,
  AshKetchum,
  AshWithFriends,
  LaprasInLake,
  Juice,
  Loader,
  SideProps,
  PokemonBadges,
  Oddish,
} from '../Models'
import Pages from '../Pages'
import '../../App.css'
const Stage = () => {
  const [isLost, setIsLost] = useState(false)
  const [page, setPage] = useState('')

  return (
    <div>
      <Suspense fallback={<Loader />}>
        <Canvas
          dpr={[1, 2]}
          mode="concurrent"
          camera={{ fov: 50, position: [0, 0.1, -10] }}
          style={{ height: '100vh', width: '100%' }}
        >
          <pointLight position={[-5, 10, -2]} intensity={1} />
          {/* <Stats
            showPanel={0} // Start-up panel (default=0)
            className="stats" // Optional className to add to the stats container dom element
          /> */}
          {/* <OrbitControls target={[-8, 0, 16]} />
          <axesHelper args={[100]} /> */}
          <fog attach="fog" args={['#ddddff', 0, 120]} />
          <ambientLight />
          <PokemonBadges />
          <Trees />
          <SideProps />
          <Skybox />
          {/* <Piano /> */}
          <Physics iterations={20} tolerance={0.0001} gravity={[0, -40, 0]}>
            <LaprasInLake page={page} />
            <Oddish page={page} />
            <AshKetchum page={page} />
            <AshWithFriends page={page} />
            <HologramConsole page={page} />
            {/* <Charizard
              page={page}
              setPage={setPage}
              setIsLost={setIsLost}
              isLost={isLost}
            /> */}
            <Juice page={page} />

            <Person page={page} setPage={setPage} />
            <Plane />
          </Physics>
          <Preload all />
          <AdaptiveDpr />
        </Canvas>
      </Suspense>
      <Pages page={page} isLost={isLost} setIsLost={setIsLost} />
    </div>
  )
}

function Plane(props) {
  // This reference will give us direct access to the mesh
  const [mesh] = usePlane(() => ({ rotation: [-Math.PI / 2, 0, 0], ...props }))
  useEffect(() => {
    mesh.current.name = 'activitymesh.ground'
  }, [])
  return (
    <mesh ref={mesh} rotation={[-Math.PI / 2, 0, 0]}>
      <planeBufferGeometry args={[140, 140]} />
      <meshBasicMaterial color="#C5dd3F" />
    </mesh>
  )
}

export default Stage
